import pick from 'lodash/pick'
import difference from 'lodash/difference'

const carryParameters = [
  'embedded',
  'email',
  'firstName',
  'lastName',
  'url',
  'currency',
  'platform',
  'industry',
  'timezone',
  'plan',
  'redirectUrl'
]

export default store => next => action => {
  if (action.type !== '@@router/LOCATION_CHANGE') {
    return next(action)
  }
  const {router: {locationBeforeTransitions}} = store.getState()
  if (locationBeforeTransitions && locationBeforeTransitions.query) {
    const {query} = locationBeforeTransitions
    const {consume} = action.payload.state || {}
    const newQuery = {
      ...pick(query, difference(carryParameters, consume)),
      ...action.payload.query
    }
    const newSearch = Object.keys(newQuery).reduce((acc, key) => acc.concat(`${key}=${newQuery[key]}`), []).join('&')
    const nextAction = {
      ...action,
      payload: {
        ...action.payload,
        query: newQuery,
        search: (newSearch ? '?' + newSearch : '')
      }
    }
    return next(nextAction)
  } else {
    return next(action)
  }
}



// WEBPACK FOOTER //
// ./client/redux/middleware/routerQueryParameters.js